import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import App from './App.tsx'

// Register SW in both dev and prod. Dev requires
// vite.config.ts → VitePWA.devOptions.enabled = true so a dev SW is generated.
// Without registration, push subscription hangs / fails with SW_NOT_REGISTERED.
registerSW({ immediate: true })

// Sync user-toggled transition setting to CSS attribute on initial load.
if (typeof window !== 'undefined') {
  const transitionsEnabled = window.localStorage.getItem('pwa-transitions-enabled') !== '0';
  document.documentElement.dataset.pwaTransitions = transitionsEnabled ? 'on' : 'off';
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
